/**
 * [一般開発者利用可]
 * メッセージ一覧
 */
export class MessageOrigin {
  static MESSAGE_ORIGINS: MessageOriginVO[] = [

    // ====================================================
    // SMS共通メッセージ
    // ====================================================
    // 言語区分
    {messageId: 'SMS99901M999L', messageContent: '日本語',},
    {messageId: 'SMS99902M999L', messageContent: 'English',},
    {messageId: 'SMS99903M999L', messageContent: 'tiếng việt',},

    // メッセージ（INFO）
    {messageId: 'SMS99901M001I', messageContent: '{1} ◆［{2}］HTTPコード：{3} {4}',},
    {messageId: 'SMS99901M002I', messageContent: '承認番号：{1}',},
    {messageId: 'SMS99901M003I', messageContent: '汎用マスタ情報取得 {1}',},
    {messageId: 'SMS99901M004I', messageContent: '{1} 入力チェック：OK',},
    {messageId: 'SMS99901M005I', messageContent: '{1} 入力チェック：NG',},
    {messageId: 'SMS99901M006I', messageContent: 'メソッド開始: class={1}, method={2}, params={3}',},
    {messageId: 'SMS99901M007I', messageContent: 'メソッド終了: class={1}, method={2}, return={3}',},

    // メッセージ（ERROR）（日本語）
    {messageId: 'SMS99901M001M', messageContent: 'お客様の情報が取得できませんでした',},
    {messageId: 'SMS99901M002M', messageContent: '３回入力を間違えました',},
    {messageId: 'SMS99901M003M', messageContent: '本人確認ができませんでした。',},
    {messageId: 'SMS99901M004M', messageContent: 'リフレッシュトークン期限切れ',},
    {messageId: 'SMS99901M005M', messageContent: '請求額未確定',},
    {messageId: 'SMS99901M006M', messageContent: '解約日を設定できません',},
    {messageId: 'SMS99901M007M', messageContent: 'お客様の情報が更新できませんでした',},
    {messageId: 'SMS99901M008M', messageContent: 'バーコードの払出しに失敗しました',},
    {messageId: 'SMS99901M009M', messageContent: '手続できません',},
    {messageId: 'SMS99901M010M', messageContent: 'バーコード支払できません',},
    {messageId: 'SMS99901M011M', messageContent: '入力内容をご確認ください',},
    {messageId: 'SMS99901M012M', messageContent: '画面を表示できませんでした',},
    {messageId: 'SMS99901M013M', messageContent: '予期せぬエラーが発生しました',},
    {messageId: 'SMS99901M014M', messageContent: 'ただいまメンテナンス中です',},
    {messageId: 'SMS99901M001E', messageContent: '情報の連携ができず、お客様の情報が取得できませんでした。しばらく経ってから再度お試しください。',},
    {messageId: 'SMS99901M002E', messageContent: '本人確認ができませんでした。\r\n下記までお電話をお願いいたします。',},
    {messageId: 'SMS99901M003E', messageContent: '入力いただいた生年月日が合致しませんでした。もう一度お試しください。',},
    {messageId: 'SMS99901M004E', messageContent: '認証情報の有効期限が切れました。取引メニューへ戻り、再度操作を行ってください。',},
    {messageId: 'SMS99901M005E', messageContent: 'ただいまご請求額確定処理中となり表示することができません。\r\n25日以降を目途に再度ご確認をお願いいたします。',},
    {messageId: 'SMS99901M006E', messageContent: 'お客様の登録内容では本システムでは解約日を設定できません。',},
    {messageId: 'SMS99901M007E', messageContent: '情報の連携ができず、お客様の情報が更新できませんでした。しばらく経ってから再度お試しください。',},
    {messageId: 'SMS99901M008E', messageContent: '支払用バーコードの生成処理に失敗しました。\r\nしばらく経ってから再度お試しください。',},
    {messageId: 'SMS99901M009E', messageContent: 'お客様については現在こちらの操作によるお手続きすることができません。\r\n詳細については下記までお電話をお願いいたします。',},
    {messageId: 'SMS99901M010E', messageContent: 'バーコードで支払可能な家賃月がありません。',},
    {messageId: 'SMS99901M011E', messageContent: '入力内容に誤りがあります。再度入力してください。',},
    {messageId: 'SMS99901M012E', messageContent: '画面表示に失敗しました。画面を更新し、再度お手続きを実行してください。',},
    {messageId: 'SMS99901M013E', messageContent: '予期せぬエラーが発生しました。\r\n下記までお電話をお願いいたします。',},
    {messageId: 'SMS99901M014E', messageContent: '現在メンテナンス中のため、ご利用いただくことができません。',},
    // メッセージ（ERROR）（英語）
    {messageId: 'SMS99902M001M', messageContent: 'Customer information could not be obtained',},
    {messageId: 'SMS99902M002M', messageContent: 'You entered the wrong information three times.',},
    {messageId: 'SMS99902M003M', messageContent: 'We were unable to verify your identity.',},
    {messageId: 'SMS99902M004M', messageContent: 'Refresh token expired',},
    {messageId: 'SMS99902M005M', messageContent: 'Billing amount not yet determined',},
    {messageId: 'SMS99902M006M', messageContent: 'Unable to set move-out date',},
    {messageId: 'SMS99902M007M', messageContent: 'Customer information could not be updated',},
    {messageId: 'SMS99902M008M', messageContent: 'Failed to issue barcode',},
    {messageId: 'SMS99902M009M', messageContent: 'I cannot complete the procedure.',},
    {messageId: 'SMS99902M010M', messageContent: 'Barcode payment not possible',},
    {messageId: 'SMS99902M011M', messageContent: 'Please check your input',},
    {messageId: 'SMS99902M012M', messageContent: 'The screen could not be displayed',},
    {messageId: 'SMS99902M013M', messageContent: 'An unexpected error has occurred',},
    {messageId: 'SMS99902M014M', messageContent: 'ただいまメンテナンス中です',},
    {messageId: 'SMS99902M001E', messageContent: 'Customer information could not be obtained because information could not be linked. Please try again after a while.',},
    {messageId: 'SMS99902M002E', messageContent: 'I couldn\'t verify my identity\r\nPlease call us at the number below.',},
    {messageId: 'SMS99902M003E', messageContent: 'The date of birth you have input does not match our records. Please try again.',},
    {messageId: 'SMS99902M004E', messageContent: 'Your authentication information has expired.Please return to the transaction menu and perform the operation again.',},
    {messageId: 'SMS99902M005E', messageContent: 'We are currently finalizing the bill amount, so we cannot display it.\r\nPlease check again from around the 25th onward.',},
    {messageId: 'SMS99902M006E', messageContent: 'The system cannot set a move-out date based on your registration information.',},
    {messageId: 'SMS99902M007E', messageContent: 'The information could not be linked and the customer\'s information could not be updated.Please try again after some time.',},
    {messageId: 'SMS99902M008E', messageContent: 'Failed to generate payment barcode.\r\nPlease try again later.',},
    {messageId: 'SMS99902M009E', messageContent: 'We are currently unable to process your request.\r\nFor more information, please call us at the number below.',},
    {messageId: 'SMS99902M010E', messageContent: 'There are no rent months that can be paid with the barcode.',},
    {messageId: 'SMS99902M011E', messageContent: 'There is an error in the entered information.Please re-enter.',},
    {messageId: 'SMS99902M012E', messageContent: 'Screen display failed.Please refresh the screen and try again.',},
    {messageId: 'SMS99902M013E', messageContent: 'An unexpected error has occurred.\r\nPlease call us at the number below.',},
    {messageId: 'SMS99902M014E', messageContent: '現在メンテナンス中のため、ご利用いただくことができません。',},
    // メッセージ（ERROR）（ベトナム語）
    {messageId: 'SMS99903M001M', messageContent: 'Không thể lấy được thông tin khách hàng',},
    {messageId: 'SMS99903M002M', messageContent: 'Quý khách đã nhập sai 3 lần',},
    {messageId: 'SMS99903M003M', messageContent: 'Không thể xác minh danh tính chính chủ',},
    {messageId: 'SMS99903M004M', messageContent: 'Mã thông báo làm mới đã hết hạn',},
    {messageId: 'SMS99903M005M', messageContent: 'Số tiền thanh toán chưa được xác định',},
    {messageId: 'SMS99903M006M', messageContent: 'Không thể ấn định ngày chuyển đi',},
    {messageId: 'SMS99903M007M', messageContent: 'Thông tin khách hàng không thể cập nhật được',},
    {messageId: 'SMS99903M008M', messageContent: 'Không thể cấp mã vạch',},
    {messageId: 'SMS99903M009M', messageContent: 'Tôi không thể hoàn tất thủ tục',},
    {messageId: 'SMS99903M010M', messageContent: 'Không thể thanh toán bằng mã vạch',},
    {messageId: 'SMS99903M011M', messageContent: 'Vui lòng kiểm tra thông tin đầu vào của bạn',},
    {messageId: 'SMS99903M012M', messageContent: 'Không thể hiển thị màn hình',},
    {messageId: 'SMS99903M013M', messageContent: 'Đã xảy ra lỗi không mong muốn',},
    {messageId: 'SMS99903M014M', messageContent: 'ただいまメンテナンス中です',},
    {messageId: 'SMS99903M001E', messageContent: 'Không thể lấy được thông tin khách hàng vì thông tin không thể liên kết được. Vui lòng thử lại sau',},
    {messageId: 'SMS99903M002E', messageContent: 'Tôi không thể xác minh danh tính của mình\r\nHãy gọi cho chúng tôi theo số bên dưới.',},
    {messageId: 'SMS99903M003E', messageContent: 'Ngày tháng năm sinh đã nhập không khớp Vui lòng thử lại',},
    {messageId: 'SMS99903M004E', messageContent: 'Thông tin đăng nhập của bạn đã hết hạn.Vui lòng quay lại menu giao dịch và thử lại.',},
    {messageId: 'SMS99903M005E', messageContent: 'Chúng tôi hiện đang xử lý để xác nhận số tiền phải thanh toán nên không thể hiển thị số tiền\r\nVui lòng xác nhận lại sau ngày 25',},
    {messageId: 'SMS99903M006E', messageContent: 'Hệ thống không thể thiết lập ngày chuyển đi dựa trên thông tin đăng ký của bạn.',},
    {messageId: 'SMS99903M007E', messageContent: 'Thông tin không thể liên kết và không thể cập nhật thông tin của khách hàng.Vui lòng thử lại sau một lúc.',},
    {messageId: 'SMS99903M008E', messageContent: 'Tạo mã vạch thanh toán không thành công.\r\nVui lòng thử lại sau một lúc.',},
    {messageId: 'SMS99903M009E', messageContent: 'Chúng tôi hiện không thể thực hiện thủ tục bằng thao tác này cho quý khách.\r\nĐể biết thêm thông tin, vui lòng gọi cho chúng tôi theo số bên dưới.',},
    {messageId: 'SMS99903M010E', messageContent: 'Hiện tại không có tháng tiền thuê phải trả nào trong mã vạch.',},
    {messageId: 'SMS99903M011E', messageContent: 'Có lỗi trong dữ liệu đầu vào.Vui lòng nhập lại lần nữa.',},
    {messageId: 'SMS99903M012E', messageContent: 'Hiển thị màn hình không thành công.Vui lòng làm mới màn hình và thử lại.',},
    {messageId: 'SMS99903M013E', messageContent: 'Đã xảy ra lỗi không mong muốn.\r\nHãy gọi cho chúng tôi theo số bên dưới.',},
    {messageId: 'SMS99903M014E', messageContent: '現在メンテナンス中のため、ご利用いただくことができません。',},

    // タイトル名
    {messageId: 'SMS99901M001T', messageContent: '株式会社オリコフォレントインシュア：IVAR',},
    {messageId: 'SMS99902M001T', messageContent: 'Orico Forrent Insure Co., Ltd.：IVAR',},
    {messageId: 'SMS99903M001T', messageContent: 'Orico Forrent Insure Co., Ltd.：IVAR',},

    // 画面文言（日本語）
    {messageId: 'SMS99901M001F', messageContent: '〒108-8555\r\n東京都港区芝浦4-9-25\r\n芝浦スクエアビル\r\n担当部署：業務統括部・特定業務部',},
    {messageId: 'SMS99901M002F', messageContent: 'Tel：',},
    {messageId: 'SMS99901M003F', messageContent: '0570-030-660',},
    {messageId: 'SMS99901M004F', messageContent: 'tel:0570030660',},
    // 画面文言（英語）
    {messageId: 'SMS99902M001F', messageContent: 'Relevant department: Operations Supervision Department/Specialized Operations Departments\r\n4-9-25 Shibaura, Minato-ku, Tokyo\r\n108-8555',},
    {messageId: 'SMS99902M002F', messageContent: 'Tel：',},
    {messageId: 'SMS99902M003F', messageContent: '0570-030-660',},
    {messageId: 'SMS99902M004F', messageContent: 'tel:0570030660',},
    // 画面文言（ベトナム語）
    {messageId: 'SMS99903M001F', messageContent: '〒108-8555\r\n4-9-25 Shibaura, quận Minato, Tokyo\r\nTòa nhà Shibaura Square Bldg.\r\nPhòng quản lý kinh doanh/Phòng công việc đặc thù　\r\nBộ phận phụ trách',},
    {messageId: 'SMS99903M002F', messageContent: 'SĐT:',},
    {messageId: 'SMS99903M003F', messageContent: '0570-030-660',},
    {messageId: 'SMS99903M004F', messageContent: 'tel:0570030660',},

    // ====================================================
    // SMS000_接続メイン
    // ====================================================
    {messageId: 'SMS00001M001I', messageContent: '接続メイン処理開始しました。',},
    {messageId: 'SMS00001M002I', messageContent: 'パラメータ取得に成功しました。',},
    {messageId: 'SMS00001M003I', messageContent: 'id：{1}',},
    {messageId: 'SMS00001M004I', messageContent: 'no：{1}',},
    {messageId: 'SMS00001M005I', messageContent: '接続メイン処理終了しました。',},
    {messageId: 'SMS00001M001E', messageContent: '接続メイン処理でエラーが発生しました。{1}',},
    {messageId: 'SMS00001M002E', messageContent: 'パラメータ取得に失敗しました。',},
    {messageId: 'SMS00001M003E', messageContent: 'パラメータ（id）の値が不正です。',},
    {messageId: 'SMS00001M004E', messageContent: 'パラメータ（no）の値が不正です。',},

    // ====================================================
    // SMS001_メインメニュー
    // ====================================================
    // メッセージ（INFO）
    {messageId: 'SMS00101M001I', messageContent: '{1}処理を開始しました。{2}',},
    {messageId: 'SMS00101M002I', messageContent: '{1}処理を完了しました。{2}',},
    {messageId: 'SMS00101M003I', messageContent: '{1}DB処理を開始しました。{2}',},
    {messageId: 'SMS00101M004I', messageContent: '接続認証に成功しました。{1}',},
    {messageId: 'SMS00101M005I', messageContent: '取得情報：{1}, {2}, {3}, {4}, {5},',},
    {messageId: 'SMS00201M006I', messageContent: '{1}ボタンが押下されました。{2}',},
    // メッセージ（ERROR）
    {messageId: 'SMS00101M001E', messageContent: '{1}処理でエラーが発生しました。{2}',},
    {messageId: 'SMS00101M002E', messageContent: '{1}ボタン処理でエラーが発生しました。{2}',},
    {messageId: 'SMS00101M003E', messageContent: 'DB処理に失敗しました。{1}',},
    {messageId: 'SMS00101M004E', messageContent: 'DB処理でエラーが発生しました。{1}',},
    {messageId: 'SMS00101M005E', messageContent: 'POSTパラメータの取得に失敗しました。',},
    // タイトル名
    {messageId: 'SMS00101M001T', messageContent: 'メインメニュー',},
    {messageId: 'SMS00102M001T', messageContent: 'Main menu',},
    {messageId: 'SMS00103M001T', messageContent: 'Thực đơn chính',},
    // 画面文言（日本語）
    {messageId: 'SMS00101M001F', messageContent: 'オリコフォレントインシュアでございます。',},
    {messageId: 'SMS00101M002F', messageContent: '貴殿がご契約された内容を下記項目から選択して確認ください。',},
    {messageId: 'SMS00101M003F', messageContent: '取引メニュー',},
    {messageId: 'SMS00101M004F', messageContent: '【お支払いに関する項目】',},
    {messageId: 'SMS00101M005F', messageContent: '【その他】',},
    {messageId: 'SMS00101M006F', messageContent: '本人確認を行います。',},
    {messageId: 'SMS00101M007F', messageContent: '生年月日を西暦で年月日の形式でご入力ください。',},
    {messageId: 'SMS00101M008F', messageContent: '生年月日',},
    {messageId: 'SMS00101M009F', messageContent: 'YYYYMMDD',},
    {messageId: 'SMS00101M010F', messageContent: '取引を行う',},
    // 画面文言（英語）
    {messageId: 'SMS00102M001F', messageContent: 'This is Orico Forrent Insure.',},
    {messageId: 'SMS00102M002F', messageContent: 'Please confirm the details of your contact by selecting from the items below.',},
    {messageId: 'SMS00102M003F', messageContent: 'Transactions Menu',},
    {messageId: 'SMS00102M004F', messageContent: '【Payment Items】',},
    {messageId: 'SMS00102M005F', messageContent: '【Other】',},
    {messageId: 'SMS00102M006F', messageContent: 'Verify Identify',},
    {messageId: 'SMS00102M007F', messageContent: 'Please input your date of birth in the year/month/date format',},
    {messageId: 'SMS00102M008F', messageContent: 'Date of birth',},
    {messageId: 'SMS00102M009F', messageContent: 'YYYYMMDD',},
    {messageId: 'SMS00102M010F', messageContent: 'Perform transaction',},
    // 画面文言（ベトナム語）
    {messageId: 'SMS00103M001F', messageContent: 'Chúng tôi là Orico Forrent Insure Co., Ltd.',},
    {messageId: 'SMS00103M002F', messageContent: 'Vui lòng chọn từ các mục bên dưới để xác nhận nội dung hợp đồng của quý khách',},
    {messageId: 'SMS00103M003F', messageContent: 'Bảng chọn giao dịch',},
    {messageId: 'SMS00103M004F', messageContent: '【Các mục liên quan đến việc thanh toán】',},
    {messageId: 'SMS00103M005F', messageContent: '【Khác】',},
    {messageId: 'SMS00103M006F', messageContent: 'Chúng tôi sẽ tiến hành xác minh danh tính chính chủ',},
    {messageId: 'SMS00103M007F', messageContent: 'Vui lòng nhập ngày tháng năm sinh của quý khách theo định dạng năm/tháng/ngày',},
    {messageId: 'SMS00103M008F', messageContent: 'Ngày tháng năm sinh',},
    {messageId: 'SMS00103M009F', messageContent: 'YYYYMMDD',},
    {messageId: 'SMS00103M010F', messageContent: 'Tiến hành giao dịch',},
    // ラジオボタン（日本語）
    {messageId: 'SMS00101M021F', messageContent: 'お家賃残高と振込先口座の確認',},
    {messageId: 'SMS00101M022F', messageContent: 'お支払い希望日を設定する場合',},
    {messageId: 'SMS00101M023F', messageContent: 'コンビニ払いを希望される方',},
    {messageId: 'SMS00101M024F', messageContent: '翌月家賃等請求額\r\n（25日以降に確認できます）',},
    {messageId: 'SMS00101M025F', messageContent: '契約物件の解約・退去の登録',},
    {messageId: 'SMS00101M026F', messageContent: '氏名変更手続き',},
    {messageId: 'SMS00101M027F', messageContent: '引落口座を設定する場合',},
    {messageId: 'SMS00101M028F', messageContent: '引落口座を変更する場合',},
    // ラジオボタン（英語）
    {messageId: 'SMS00102M021F', messageContent: 'Rent balance and account for transfers confirmation',},
    {messageId: 'SMS00102M022F', messageContent: 'To set your desired payment date',},
    {messageId: 'SMS00102M023F', messageContent: 'For those who wish to pay at a convenience store',},
    {messageId: 'SMS00102M024F', messageContent: 'Next month\'s rent bill\r\n (You can check this from the 25th onward)',},
    {messageId: 'SMS00102M025F', messageContent: 'Property contract cancelation and moving out registration',},
    {messageId: 'SMS00102M026F', messageContent: 'Name change process',},
    {messageId: 'SMS00102M027F', messageContent: 'To set up a direct debit account',},
    {messageId: 'SMS00102M028F', messageContent: 'To change your direct debit account',},
    // ラジオボタン（ベトナム語）
    {messageId: 'SMS00103M021F', messageContent: 'Xác nhận số dư tiền thuê nhà và tài khoản chuyển khoản',},
    {messageId: 'SMS00103M022F', messageContent: 'Khi thiết lập ngày thanh toán mong muốn',},
    {messageId: 'SMS00103M023F', messageContent: 'Những quý khách muốn thanh toán tại cửa hàng tiện lợi',},
    {messageId: 'SMS00103M024F', messageContent: 'Số tiền phải thanh toán chẳng hạn như tiền thuê nhà tháng tiếp theo, v.v.\r\n (Quý khách có thể xác nhận sau ngày 25)',},
    {messageId: 'SMS00103M025F', messageContent: 'Đăng ký hủy thuê nhà theo hợp đồng/chuyển đi',},
    {messageId: 'SMS00103M026F', messageContent: 'Thủ tục đổi tên',},
    {messageId: 'SMS00103M027F', messageContent: 'Thiết lập tài khoản rút tiền',},
    {messageId: 'SMS00103M028F', messageContent: 'Thay đổi tài khoản rút tiền',},

    // ====================================================
    // SMS002_契約情報
    // ====================================================
    // メッセージ（INFO）
    {messageId: 'SMS00201M001I', messageContent: '{1} {2}処理を開始しました。',},
    {messageId: 'SMS00201M002I', messageContent: '{1} {2}処理を完了しました。',},
    {messageId: 'SMS00201M003I', messageContent: '{1} {2}DB処理を開始しました。',},
    {messageId: 'SMS00201M004I', messageContent: '{1} {2}DB処理が完了しました。',},
    {messageId: 'SMS00201M005I', messageContent: '{1} {2}ボタンが押下されました。',},
    // メッセージ（ERROR）
    {messageId: 'SMS00201M001E', messageContent: '{1} {2}処理でエラーが発生しました。',},
    {messageId: 'SMS00201M002E', messageContent: '{1} {2}ボタン処理でエラーが発生しました。',},
    {messageId: 'SMS00201M003E', messageContent: '{1} DB処理に失敗しました。',},
    {messageId: 'SMS00201M004E', messageContent: '{1} DB処理でエラーが発生しました。',},
    {messageId: 'SMS00201M005E', messageContent: 'ログイン情報の取得に失敗しました。',},
    {messageId: 'SMS00201M006E', messageContent: 'POSTパラメータの取得に失敗しました。',},
    // タイトル名
    {messageId: 'SMS00201M001T', messageContent: '契約情報',},
    {messageId: 'SMS00202M001T', messageContent: 'Contract Information',},
    {messageId: 'SMS00203M001T', messageContent: 'Thông tin hợp đồng',},
    // 画面文言（日本語）
    {messageId: 'SMS00201M001F', messageContent: 'こちらでお間違いないですか',},
    {messageId: 'SMS00201M002F', messageContent: '氏名 姓',},
    {messageId: 'SMS00201M003F', messageContent: '名',},
    {messageId: 'SMS00201M004F', messageContent: '氏名 セイ',},
    {messageId: 'SMS00201M005F', messageContent: 'メイ',},
    {messageId: 'SMS00201M006F', messageContent: '生年月日',},
    {messageId: 'SMS00201M007F', messageContent: '今お住まいの物件名',},
    {messageId: 'SMS00201M008F', messageContent: '号室',},
    {messageId: 'SMS00201M009F', messageContent: '契約開始日',},
    {messageId: 'SMS00201M010F', messageContent: '送信',},
    {messageId: 'SMS00201M011F', messageContent: 'メニューへ戻る',},
    // 画面文言（英語）
    {messageId: 'SMS00202M001F', messageContent: 'Is this information correct?',},
    {messageId: 'SMS00202M002F', messageContent: 'Surname',},
    {messageId: 'SMS00202M003F', messageContent: 'First name',},
    {messageId: 'SMS00202M004F', messageContent: 'Surname',},
    {messageId: 'SMS00202M005F', messageContent: 'First name',},
    {messageId: 'SMS00202M006F', messageContent: 'Date of birth',},
    {messageId: 'SMS00202M007F', messageContent: 'Name of the property you are living in now',},
    {messageId: 'SMS00202M008F', messageContent: 'Room number',},
    {messageId: 'SMS00202M009F', messageContent: 'Contract start date',},
    {messageId: 'SMS00202M010F', messageContent: 'Send',},
    {messageId: 'SMS00202M011F', messageContent: 'Return to menu',},
    // 画面文言（ベトナム語）
    {messageId: 'SMS00203M001F', messageContent: 'Quý khách có chắc chắn thông tin là chính xác không',},
    {messageId: 'SMS00203M002F', messageContent: '(Kanji) Họ',},
    {messageId: 'SMS00203M003F', messageContent: 'Tên',},
    {messageId: 'SMS00203M004F', messageContent: '(Katakana) Họ',},
    {messageId: 'SMS00203M005F', messageContent: 'Tên',},
    {messageId: 'SMS00203M006F', messageContent: 'Ngày tháng năm sinh',},
    {messageId: 'SMS00203M007F', messageContent: 'Tên căn nhà hiện tại quý khách đang ở',},
    {messageId: 'SMS00203M008F', messageContent: 'Số phòng',},
    {messageId: 'SMS00203M009F', messageContent: 'Ngày bắt đầu hợp đồng',},
    {messageId: 'SMS00203M010F', messageContent: 'gửi',},
    {messageId: 'SMS00203M011F', messageContent: 'Quay lại trình đơn',},

    // ====================================================
    // SMS003_現在残高・支払希望日/支払日確認
    // ====================================================
    // メッセージ（INFO）
    {messageId: 'SMS00301M001I', messageContent: '{1} {2}処理を開始しました。',},
    {messageId: 'SMS00301M002I', messageContent: '{1} {2}処理を完了しました。',},
    {messageId: 'SMS00301M003I', messageContent: '{1} {2}DB処理を開始しました。',},
    {messageId: 'SMS00301M004I', messageContent: '{1} {2}DB処理が完了しました。',},
    {messageId: 'SMS00301M005I', messageContent: '{1} {2}ボタンが押下されました。',},
    // メッセージ（ERROR）
    {messageId: 'SMS00301M001E', messageContent: '{1} {2}処理でエラーが発生しました。',},
    {messageId: 'SMS00301M002E', messageContent: '{1} {2}ボタン処理でエラーが発生しました。',},
    {messageId: 'SMS00301M003E', messageContent: '{1} DB処理に失敗しました。',},
    {messageId: 'SMS00301M004E', messageContent: '{1} DB処理でエラーが発生しました。',},
    {messageId: 'SMS00301M005E', messageContent: 'ログイン情報の取得に失敗しました。',},
    // タイトル名
    {messageId: 'SMS00301M001T', messageContent: '現在残高・支払希望日',},
    {messageId: 'SMS00301M002T', messageContent: '支払日確認',},
    {messageId: 'SMS00302M001T', messageContent: 'Current Balance and Desired Payment Date',},
    {messageId: 'SMS00302M002T', messageContent: 'Payment Date Confirmation',},
    {messageId: 'SMS00303M001T', messageContent: 'Số dư hiện tại/Ngày thanh toán mong muốn',},
    {messageId: 'SMS00303M002T', messageContent: 'Xác nhận ngày thanh toán',},
    // 画面文言（日本語）
    {messageId: 'SMS00301M001F', messageContent: '{1}　{2} 様',},
    {messageId: 'SMS00301M002F', messageContent: 'オリコフォレントインシュアでございます。',},
    {messageId: 'SMS00301M003F', messageContent: '未納金額は以下となります。',},
    {messageId: 'SMS00301M004F', messageContent: '以下の内容でお支払約束が登録されております。',},
    {messageId: 'SMS00301M005F', messageContent: '{1}年{2}月分',},
    {messageId: 'SMS00301M006F', messageContent: '合計',},
    {messageId: 'SMS00301M007F', messageContent: '{1} 円',},
    {messageId: 'SMS00301M008F', messageContent: '【支払希望日】',},
    {messageId: 'SMS00301M009F', messageContent: '【支払日】',},
    {messageId: 'SMS00301M010F', messageContent: 'MM',},
    {messageId: 'SMS00301M011F', messageContent: '月',},
    {messageId: 'SMS00301M012F', messageContent: 'DD',},
    {messageId: 'SMS00301M013F', messageContent: '日',},
    {messageId: 'SMS00301M014F', messageContent: '当月21日以降の支払日登録はできませんのでお電話ください。',},
    {messageId: 'SMS00301M015F', messageContent: '一括でのお支払いが難しい場合は、当社までお電話ください。',},
    {messageId: 'SMS00301M016F', messageContent: '詳細金額表示へ',},
    {messageId: 'SMS00301M017F', messageContent: '送信',},
    {messageId: 'SMS00301M018F', messageContent: 'メニューへ戻る',},
    // 画面文言（英語）
    {messageId: 'SMS00302M001F', messageContent: 'Dear {1}　{2}',},
    {messageId: 'SMS00302M002F', messageContent: 'This is Orico Forrent Insure.',},
    {messageId: 'SMS00302M003F', messageContent: 'The amount you have yet to pay is below.',},
    {messageId: 'SMS00302M004F', messageContent: 'A payment promise has been registered with the following details.',},
    {messageId: 'SMS00302M005F', messageContent: 'Rent for {2}/ {1}:',},
    {messageId: 'SMS00302M006F', messageContent: 'Total',},
    {messageId: 'SMS00302M007F', messageContent: '{1} yen',},
    {messageId: 'SMS00302M008F', messageContent: '【Desired Payment Date】',},
    {messageId: 'SMS00302M009F', messageContent: '【Payment Date】',},
    {messageId: 'SMS00302M010F', messageContent: 'MM',},
    {messageId: 'SMS00302M011F', messageContent: 'MM',},
    {messageId: 'SMS00302M012F', messageContent: 'DD',},
    {messageId: 'SMS00302M013F', messageContent: 'DD',},
    {messageId: 'SMS00302M014F', messageContent: 'Please call us as we cannot register payment dates after the 21st of the month.',},
    {messageId: 'SMS00302M015F', messageContent: 'Please call us if it is difficult to pay all at once.',},
    {messageId: 'SMS00302M016F', messageContent: 'Go to detailed amount display',},
    {messageId: 'SMS00302M017F', messageContent: 'Send',},
    {messageId: 'SMS00302M018F', messageContent: 'Return to menu',},
    // 画面文言（ベトナム語）
    {messageId: 'SMS00303M001F', messageContent: 'Khách hàng {1}　{2}',},
    {messageId: 'SMS00303M002F', messageContent: 'Chúng tôi là Orico Forrent Insure Co.,Ltd.',},
    {messageId: 'SMS00303M003F', messageContent: 'Số tiền chưa thanh toán của quý khách như sau',},
    {messageId: 'SMS00303M004F', messageContent: 'Lời hứa thanh toán đã được đăng ký với các chi tiết sau đây.',},
    {messageId: 'SMS00303M005F', messageContent: 'tháng{2} năm{1}',},
    {messageId: 'SMS00303M006F', messageContent: 'Tổng cộng',},
    {messageId: 'SMS00303M007F', messageContent: '{1} Yên',},
    {messageId: 'SMS00303M008F', messageContent: '【Ngày thanh toán mong muốn】',},
    {messageId: 'SMS00303M009F', messageContent: '【Ngày thanh toán】',},
    {messageId: 'SMS00303M010F', messageContent: 'MM',},
    {messageId: 'SMS00303M011F', messageContent: 'tháng',},
    {messageId: 'SMS00303M012F', messageContent: 'DD',},
    {messageId: 'SMS00303M013F', messageContent: 'ngày',},
    {messageId: 'SMS00303M014F', messageContent: 'Vui lòng gọi cho chúng tôi vì chúng tôi không thể đăng ký ngày thanh toán sau ngày 21 của tháng.',},
    {messageId: 'SMS00303M015F', messageContent: 'Nếu quý khách gặp khó khăn trong việc thanh toán tất cả một lần, vui lòng gọi cho công ty chúng tôi.',},
    {messageId: 'SMS00303M016F', messageContent: 'Chuyển đến phần hiển thị số tiền chi tiết',},
    {messageId: 'SMS00303M017F', messageContent: 'gửi',},
    {messageId: 'SMS00303M018F', messageContent: 'Quay lại trình đơn',},

    // ====================================================
    // SMS004_コンビニ収納サービス
    // ====================================================
    // メッセージ（INFO）
    {messageId: 'SMS00401M001I', messageContent: '{1} {2}処理を開始しました。',},
    {messageId: 'SMS00401M002I', messageContent: '{1} {2}処理を完了しました。',},
    {messageId: 'SMS00401M003I', messageContent: '{1} {2}DB処理を開始しました。',},
    {messageId: 'SMS00401M004I', messageContent: '{1} {2}DB処理が完了しました。',},
    {messageId: 'SMS00401M005I', messageContent: '{1} {2}ボタンが押下されました。',},
    // メッセージ（ERROR）
    {messageId: 'SMS00401M001E', messageContent: '{1} {2}処理でエラーが発生しました。',},
    {messageId: 'SMS00401M002E', messageContent: '{1} {2}ボタン処理でエラーが発生しました。',},
    {messageId: 'SMS00401M003E', messageContent: '{1} DB処理に失敗しました。',},
    {messageId: 'SMS00401M004E', messageContent: '{1} DB処理でエラーが発生しました。',},
    {messageId: 'SMS00401M005E', messageContent: 'ログイン情報の取得に失敗しました。',},
    // タイトル名
    {messageId: 'SMS00401M001T', messageContent: 'コンビニ収納サービス',},
    {messageId: 'SMS00402M001T', messageContent: 'Convenience Store Payment Receipt Service',},
    {messageId: 'SMS00403M001T', messageContent: 'Dịch vụ thu hộ của cửa hàng tiện lợi',},
    // 画面文言（日本語）
    {messageId: 'SMS00401M001F', messageContent: '{1}　{2} 様',},
    {messageId: 'SMS00401M002F', messageContent: 'オリコフォレントインシュアでございます。',},
    {messageId: 'SMS00401M003F', messageContent: 'お支払いになる家賃月を選択しコンビニ払いバーコード発行ボタンを押してください。',},
    {messageId: 'SMS00401M004F', messageContent: '支払用バーコードが表示されます。',},
    {messageId: 'SMS00401M005F', messageContent: '※30万円を超過する支払額はバーコードでの支払いはできません。',},
    {messageId: 'SMS00401M006F', messageContent: 'コンビニ払いバーコード発行',},
    {messageId: 'SMS00401M007F', messageContent: '詳細金額表示へ',},
    {messageId: 'SMS00401M008F', messageContent: 'メニューへ戻る',},
    {messageId: 'SMS00401M009F', messageContent: '{1}年{2}月分',},
    {messageId: 'SMS00401M010F', messageContent: '{1} 円',},
    // 画面文言（英語）
    {messageId: 'SMS00402M001F', messageContent: 'Dear {1}　{2}',},
    {messageId: 'SMS00402M002F', messageContent: 'This is Orico Forrent Insure.',},
    {messageId: 'SMS00402M003F', messageContent: 'Please select the month of rent you will pay and then press the "Send" button.',},
    {messageId: 'SMS00402M004F', messageContent: 'A barcode for payment will be displayed.',},
    {messageId: 'SMS00402M005F', messageContent: '*Payment amounts exceeding 300,000 yen cannot be paid using barcodes.',},
    {messageId: 'SMS00402M006F', messageContent: 'To issue a barcode for convenience store payment',},
    {messageId: 'SMS00402M007F', messageContent: 'Go to detailed amount display',},
    {messageId: 'SMS00402M008F', messageContent: 'Return to menu',},
    {messageId: 'SMS00402M009F', messageContent: 'Rent for {2}/ {1}:',},
    {messageId: 'SMS00402M010F', messageContent: '{1} yen',},
    // 画面文言（ベトナム語）
    {messageId: 'SMS00403M001F', messageContent: 'Khách hàng {1}　{2}',},
    {messageId: 'SMS00403M002F', messageContent: 'Chúng tôi là Orico Forrent Insure Co.,Ltd.',},
    {messageId: 'SMS00403M003F', messageContent: 'Chọn số tiền thuê nhà tháng bạn muốn thanh toán và nhấp vào gửi.',},
    {messageId: 'SMS00403M004F', messageContent: 'Mã vạch thanh toán sẽ được hiển thị.',},
    {messageId: 'SMS00403M005F', messageContent: '*Không thể thanh toán số tiền vượt quá 300.000 yên bằng mã vạch.',},
    {messageId: 'SMS00403M006F', messageContent: 'Xuất mã vạch thanh toán tại cửa hàng tiện lợi',},
    {messageId: 'SMS00403M007F', messageContent: 'Chuyển đến phần hiển thị số tiền chi tiết',},
    {messageId: 'SMS00403M008F', messageContent: 'Quay lại trình đơn',},
    {messageId: 'SMS00403M009F', messageContent: 'tháng{2} năm{1}',},
    {messageId: 'SMS00403M010F', messageContent: '{1} Yên',},

    // ====================================================
    // SMS005_家賃残高・振込口座確認
    // ====================================================
    // メッセージ（INFO）
    {messageId: 'SMS00501M001I', messageContent: '{1} {2}処理を開始しました。',},
    {messageId: 'SMS00501M002I', messageContent: '{1} {2}処理を完了しました。',},
    {messageId: 'SMS00501M003I', messageContent: '{1} {2}DB処理を開始しました。',},
    {messageId: 'SMS00501M004I', messageContent: '{1} {2}DB処理が完了しました。',},
    {messageId: 'SMS00501M005I', messageContent: '{1} {2}ボタンが押下されました。',},
    // メッセージ（ERROR）
    {messageId: 'SMS00501M001E', messageContent: '{1} {2}処理でエラーが発生しました。',},
    {messageId: 'SMS00501M002E', messageContent: '{1} {2}ボタン処理でエラーが発生しました。',},
    {messageId: 'SMS00501M003E', messageContent: '{1} DB処理に失敗しました。',},
    {messageId: 'SMS00501M004E', messageContent: '{1} DB処理でエラーが発生しました。',},
    {messageId: 'SMS00501M005E', messageContent: 'ログイン情報の取得に失敗しました。',},
    // タイトル名
    {messageId: 'SMS00501M001T', messageContent: '家賃残高・振込口座確認',},
    {messageId: 'SMS00502M001T', messageContent: 'Rent Balance and Account for Transfers Confirmation',},
    {messageId: 'SMS00503M001T', messageContent: 'Xác nhận số dư tiền thuê nhà/tài khoản chuyển khoản',},
    // 画面文言（日本語）
    {messageId: 'SMS00501M001F', messageContent: '{1}　{2} 様',},
    {messageId: 'SMS00501M002F', messageContent: 'オリコフォレントインシュアでございます。',},
    {messageId: 'SMS00501M003F', messageContent: '【現在のお家賃残高】',},
    {messageId: 'SMS00501M004F', messageContent: '{1}年{2}月分',},
    {messageId: 'SMS00501M005F', messageContent: '合計',},
    {messageId: 'SMS00501M006F', messageContent: '{1} 円',},
    {messageId: 'SMS00501M007F', messageContent: 'になります。',},
    {messageId: 'SMS00501M008F', messageContent: '（{1}年{2}月{3}日時点）',},
    {messageId: 'SMS00501M009F', messageContent: '【振込先口座】',},
    {messageId: 'SMS00501M010F', messageContent: '詳細金額表示へ',},
    {messageId: 'SMS00501M011F', messageContent: 'メニューへ戻る',},
    // 画面文言（英語）
    {messageId: 'SMS00502M001F', messageContent: 'Dear {1}　{2}',},
    {messageId: 'SMS00502M002F', messageContent: 'This is Orico Forrent Insure.',},
    {messageId: 'SMS00502M003F', messageContent: '【Current Rent Balance】',},
    {messageId: 'SMS00502M004F', messageContent: 'Rent for {2}/ {1}',},
    {messageId: 'SMS00502M005F', messageContent: 'Total',},
    {messageId: 'SMS00502M006F', messageContent: '{1} yen',},
    {messageId: 'SMS00502M007F', messageContent: '',},
    {messageId: 'SMS00502M008F', messageContent: '(As of {2}/ {3}, {1})',},
    {messageId: 'SMS00502M009F', messageContent: '【Account for Transfers】',},
    {messageId: 'SMS00502M010F', messageContent: 'Go to detailed amount display',},
    {messageId: 'SMS00502M011F', messageContent: 'Return to menu',},
    // 画面文言（ベトナム語）
    {messageId: 'SMS00503M001F', messageContent: 'Khách hàng {1}　{2}',},
    {messageId: 'SMS00503M002F', messageContent: 'Chúng tôi là Orico Forrent Insure Co.,Ltd.',},
    {messageId: 'SMS00503M003F', messageContent: '【Số dư tiền thuê nhà hiện tại】',},
    {messageId: 'SMS00503M004F', messageContent: 'tháng{2} năm{1}',},
    {messageId: 'SMS00503M005F', messageContent: 'Tổng cộng',},
    {messageId: 'SMS00503M006F', messageContent: '{1} Yên',},
    {messageId: 'SMS00503M007F', messageContent: '',},
    {messageId: 'SMS00503M008F', messageContent: '(Tính đến thời điểm ngày{3} tháng{2} năm{1})',},
    {messageId: 'SMS00503M009F', messageContent: '【Tài khoản đích chuyển tiền】',},
    {messageId: 'SMS00503M010F', messageContent: 'Chuyển đến phần hiển thị số tiền chi tiết',},
    {messageId: 'SMS00503M011F', messageContent: 'Quay lại trình đơn',},

    // ====================================================
    // SMS006_請求金額確認
    // ====================================================
    // メッセージ（INFO）
    {messageId: 'SMS00601M001I', messageContent: '{1} {2}処理を開始しました。',},
    {messageId: 'SMS00601M002I', messageContent: '{1} {2}処理を完了しました。',},
    {messageId: 'SMS00601M003I', messageContent: '{1} {2}DB処理を開始しました。',},
    {messageId: 'SMS00601M004I', messageContent: '{1} {2}DB処理が完了しました。',},
    {messageId: 'SMS00601M005I', messageContent: '{1} {2}ボタンが押下されました。',},
    // メッセージ（ERROR）
    {messageId: 'SMS00601M001E', messageContent: '{1} {2}処理でエラーが発生しました。',},
    {messageId: 'SMS00601M002E', messageContent: '{1} {2}ボタン処理でエラーが発生しました。',},
    {messageId: 'SMS00601M003E', messageContent: '{1} DB処理に失敗しました。',},
    {messageId: 'SMS00601M004E', messageContent: '{1} DB処理でエラーが発生しました。',},
    {messageId: 'SMS00601M005E', messageContent: 'ログイン情報の取得に失敗しました。',},
    // タイトル名
    {messageId: 'SMS00601M001T', messageContent: '請求金額確認',},
    {messageId: 'SMS00602M001T', messageContent: 'Billing Amount Confirmation',},
    {messageId: 'SMS00603M001T', messageContent: 'Xác nhận số tiền yêu cầu thanh toán',},
    // 画面文言（日本語）
    {messageId: 'SMS00601M001F', messageContent: '{1}　{2} 様',},
    {messageId: 'SMS00601M002F', messageContent: 'オリコフォレントインシュアでございます。',},
    {messageId: 'SMS00601M003F', messageContent: '【{1}月分請求額】',},
    {messageId: 'SMS00601M004F', messageContent: '{1}年{2}月分',},
    {messageId: 'SMS00601M005F', messageContent: '{1} 円',},
    {messageId: 'SMS00601M006F', messageContent: '（{1}年{2}月{3}日時点）',},
    {messageId: 'SMS00601M007F', messageContent: 'になります。',},
    {messageId: 'SMS00601M008F', messageContent: 'メニューへ戻る',},
    // 画面文言（英語）
    {messageId: 'SMS00602M001F', messageContent: 'Dear {1}　{2}',},
    {messageId: 'SMS00602M002F', messageContent: 'This is Orico Forrent Insure.',},
    {messageId: 'SMS00602M003F', messageContent: '【{1}/{2} Rent etc.】',},
    {messageId: 'SMS00602M004F', messageContent: 'Rent for {2}/ {1}:',},
    {messageId: 'SMS00602M005F', messageContent: '{1} yen',},
    {messageId: 'SMS00602M006F', messageContent: '(As of {2}/ {3}, {1})',},
    {messageId: 'SMS00602M007F', messageContent: '',},
    {messageId: 'SMS00602M008F', messageContent: 'Return to menu',},
    // 画面文言（ベトナム語）
    {messageId: 'SMS00603M001F', messageContent: 'Khách hàng {1}　{2}',},
    {messageId: 'SMS00603M002F', messageContent: 'Chúng tôi là Orico Forrent Insure Co.,Ltd.',},
    {messageId: 'SMS00603M003F', messageContent: '【Số tiền phải thanh toán cho tháng{1}】',},
    {messageId: 'SMS00603M004F', messageContent: 'tháng{2} năm{1}',},
    {messageId: 'SMS00603M005F', messageContent: '{1} Yên',},
    {messageId: 'SMS00603M006F', messageContent: '(Tính đến thời điểm ngày{3} tháng{2} năm{1})',},
    {messageId: 'SMS00603M007F', messageContent: '',},
    {messageId: 'SMS00603M008F', messageContent: 'Quay lại trình đơn',},

    // ====================================================
    // SMS007_解約・退去予定日登録
    // ====================================================
    // メッセージ（INFO）
    {messageId: 'SMS00701M001I', messageContent: '{1} {2}処理を開始しました。',},
    {messageId: 'SMS00701M002I', messageContent: '{1} {2}処理を完了しました。',},
    {messageId: 'SMS00701M003I', messageContent: '{1} {2}DB処理を開始しました。',},
    {messageId: 'SMS00701M004I', messageContent: '{1} {2}DB処理が完了しました。',},
    {messageId: 'SMS00701M005I', messageContent: '{1} {2}ボタンが押下されました。',},
    // メッセージ（ERROR）
    {messageId: 'SMS00701M001E', messageContent: '{1} {2}処理でエラーが発生しました。',},
    {messageId: 'SMS00701M002E', messageContent: '{1} {2}ボタン処理でエラーが発生しました。',},
    {messageId: 'SMS00701M003E', messageContent: '{1} DB処理に失敗しました。',},
    {messageId: 'SMS00701M004E', messageContent: '{1} DB処理でエラーが発生しました。',},
    {messageId: 'SMS00701M005E', messageContent: 'ログイン情報の取得に失敗しました。',},
    // タイトル名
    {messageId: 'SMS00701M001T', messageContent: '解約・退去予定日登録',},
    {messageId: 'SMS00702M001T', messageContent: 'Cancelation and Scheduled Moving out Date Registration',},
    {messageId: 'SMS00703M001T', messageContent: 'Đăng ký ngày dự kiến hủy/chuyển đi',},
    // 画面文言（日本語）
    {messageId: 'SMS00701M001F', messageContent: '{1}　{2} 様',},
    {messageId: 'SMS00701M002F', messageContent: 'オリコフォレントインシュアでございます。',},
    {messageId: 'SMS00701M003F', messageContent: '退去日（退去予定日）を入力してください。',},
    {messageId: 'SMS00701M004F', messageContent: 'YYYY',},
    {messageId: 'SMS00701M005F', messageContent: '年',},
    {messageId: 'SMS00701M006F', messageContent: 'MM',},
    {messageId: 'SMS00701M007F', messageContent: '月',},
    {messageId: 'SMS00701M008F', messageContent: 'DD',},
    {messageId: 'SMS00701M009F', messageContent: '日',},
    {messageId: 'SMS00701M010F', messageContent: 'この画面で解約受付は出来ませんので、ご注意ください。',},
    {messageId: 'SMS00701M011F', messageContent: '（オリコフォレントインシュアにのみ通知されます）',},
    {messageId: 'SMS00701M012F', messageContent: '解約手続きは、契約内容および管理会社への確認をお願いいたします。',},
    {messageId: 'SMS00701M013F', messageContent: '送信',},
    {messageId: 'SMS00701M014F', messageContent: 'メニューへ戻る',},
    // 画面文言（英語）
    {messageId: 'SMS00702M001F', messageContent: 'Dear {1}　{2}',},
    {messageId: 'SMS00702M002F', messageContent: 'This is Orico Forrent Insure.',},
    {messageId: 'SMS00702M003F', messageContent: 'Please input your moving out date (scheduled moving out date).',},
    {messageId: 'SMS00702M004F', messageContent: 'YYYY',},
    {messageId: 'SMS00702M005F', messageContent: 'YYYY',},
    {messageId: 'SMS00702M006F', messageContent: 'MM',},
    {messageId: 'SMS00702M007F', messageContent: 'MM',},
    {messageId: 'SMS00702M008F', messageContent: 'DD',},
    {messageId: 'SMS00702M009F', messageContent: 'DD',},
    {messageId: 'SMS00702M010F', messageContent: 'Please note that you cannot cancel your contact on this screen.',},
    {messageId: 'SMS00702M011F', messageContent: '(Only Orico Forrent Insure will be notified.)',},
    {messageId: 'SMS00702M012F', messageContent: 'Please confirm your contract details and the management company before undertaking the contract cancelation process.',},
    {messageId: 'SMS00702M013F', messageContent: 'Send',},
    {messageId: 'SMS00702M014F', messageContent: 'Return to menu',},
    // 画面文言（ベトナム語）
    {messageId: 'SMS00703M001F', messageContent: 'Khách hàng {1}　{2}',},
    {messageId: 'SMS00703M002F', messageContent: 'Chúng tôi là Orico Forrent Insure Co.,Ltd.',},
    {messageId: 'SMS00703M003F', messageContent: 'Vui lòng nhập ngày chuyển đi (ngày dự kiến chuyển đi) của quý khách',},
    {messageId: 'SMS00703M004F', messageContent: 'YYYY',},
    {messageId: 'SMS00703M005F', messageContent: 'năm',},
    {messageId: 'SMS00703M006F', messageContent: 'MM',},
    {messageId: 'SMS00703M007F', messageContent: 'tháng',},
    {messageId: 'SMS00703M008F', messageContent: 'DD',},
    {messageId: 'SMS00703M009F', messageContent: 'ngày',},
    {messageId: 'SMS00703M010F', messageContent: 'Xin lưu ý rằng chúng tôi không thể tiếp nhận yêu cầu hủy bỏ tại màn hình này.',},
    {messageId: 'SMS00703M011F', messageContent: '(Yêu cầu chỉ được thông báo đến Orico Forrent Insure)',},
    {messageId: 'SMS00703M012F', messageContent: 'Vui lòng kiểm tra nội dung hợp đồng và xác nhận với công ty quản lý để biết thủ tục hủy hợp đồng.',},
    {messageId: 'SMS00703M013F', messageContent: 'gửi',},
    {messageId: 'SMS00703M014F', messageContent: 'Quay lại trình đơn',},

    // ====================================================
    // SMS008_請求金額詳細
    // ====================================================
    // メッセージ（INFO）
    {messageId: 'SMS00801M001I', messageContent: '{1} {2}処理を開始しました。',},
    {messageId: 'SMS00801M002I', messageContent: '{1} {2}処理を完了しました。',},
    {messageId: 'SMS00801M003I', messageContent: '{1} {2}DB処理を開始しました。',},
    {messageId: 'SMS00801M004I', messageContent: '{1} {2}DB処理が完了しました。',},
    {messageId: 'SMS00801M005I', messageContent: '{1} {2}ボタンが押下されました。',},
    // メッセージ（ERROR）
    {messageId: 'SMS00801M001E', messageContent: '{1} {2}処理でエラーが発生しました。',},
    {messageId: 'SMS00801M002E', messageContent: '{1} {2}ボタン処理でエラーが発生しました。',},
    {messageId: 'SMS00801M003E', messageContent: '{1} DB処理に失敗しました。',},
    {messageId: 'SMS00801M004E', messageContent: '{1} DB処理でエラーが発生しました。',},
    {messageId: 'SMS00801M005E', messageContent: 'ログイン情報の取得に失敗しました。',},
    {messageId: 'SMS00801M006E', messageContent: 'POSTパラメータの取得に失敗しました。',},
    // タイトル名
    {messageId: 'SMS00801M001T', messageContent: '請求金額詳細',},
    {messageId: 'SMS00802M001T', messageContent: 'Billing Amount Details',},
    {messageId: 'SMS00803M001T', messageContent: 'Chi tiết số tiền yêu cầu thanh toán',},
    // 画面文言（日本語）
    {messageId: 'SMS00801M001F', messageContent: '{1} 円',},
    {messageId: 'SMS00801M002F', messageContent: '(取得日：{1}年{2}月{3}日)',},
    {messageId: 'SMS00801M003F', messageContent: '{1} 賃料詳細',},
    {messageId: 'SMS00801M004F', messageContent: '{1}年{2}月元金',},
    {messageId: 'SMS00801M005F', messageContent: '保証委託料・支払手数料',},
    {messageId: 'SMS00801M006F', messageContent: '収納手数料・決済サービス',},
    {messageId: 'SMS00801M007F', messageContent: '包括費用',},
    {messageId: 'SMS00801M008F', messageContent: '少額短期保険',},
    {messageId: 'SMS00801M009F', messageContent: '遅延損害金',},
    {messageId: 'SMS00801M010F', messageContent: '再請求手数料',},
    {messageId: 'SMS00801M011F', messageContent: '催告費用（書類作成代）',},
    {messageId: 'SMS00801M012F', messageContent: '催告費用（郵送代）',},
    {messageId: 'SMS00801M013F', messageContent: 'コンビニ払いバーコード発行',},
    {messageId: 'SMS00801M014F', messageContent: '家賃振込先表示へ',},
    {messageId: 'SMS00801M015F', messageContent: 'メニューへ戻る',},
    // 画面文言（英語）
    {messageId: 'SMS00802M001F', messageContent: '{1} yen',},
    {messageId: 'SMS00802M002F', messageContent: '(Retrieved date: {2} month {3}, {1} year)',},
    {messageId: 'SMS00802M003F', messageContent: '{1} Rent details',},
    {messageId: 'SMS00802M004F', messageContent: '{1} year {2} month principal',},
    {messageId: 'SMS00802M005F', messageContent: 'Guarantee consignment fee/payment fee',},
    {messageId: 'SMS00802M006F', messageContent: 'Payment service fee',},
    {messageId: 'SMS00802M007F', messageContent: 'inclusive cost',},
    {messageId: 'SMS00802M008F', messageContent: 'Small-amount short-term insurance',},
    {messageId: 'SMS00802M009F', messageContent: 'Late damages fee',},
    {messageId: 'SMS00802M010F', messageContent: 'Re-bill handling fee',},
    {messageId: 'SMS00802M011F', messageContent: 'Notice charge\r\n(document preparation fee)',},
    {messageId: 'SMS00802M012F', messageContent: 'Notice charge\r\n(postage fee)',},
    {messageId: 'SMS00802M013F', messageContent: 'To issue a barcode for convenience store payment',},
    {messageId: 'SMS00802M014F', messageContent: 'To display the rent transfer destination',},
    {messageId: 'SMS00802M015F', messageContent: 'Return to menu',},
    // 画面文言（ベトナム語）
    {messageId: 'SMS00803M001F', messageContent: '{1} Yên',},
    {messageId: 'SMS00803M002F', messageContent: '(Ngày mua lại: {2} tháng {3} của {1} năm)',},
    {messageId: 'SMS00803M003F', messageContent: '{1} Chi tiết tiền thuê',},
    {messageId: 'SMS00803M004F', messageContent: 'tiền thuê nhà {1} năm {2} tháng',},
    {messageId: 'SMS00803M005F', messageContent: 'Phí ủy thác bảo lãnh/Phí thanh toán',},
    {messageId: 'SMS00803M006F', messageContent: 'tiền hoa hồng',},
    {messageId: 'SMS00803M007F', messageContent: 'chi phí toàn diện',},
    {messageId: 'SMS00803M008F', messageContent: 'Bảo hiểm ngắn hạn cho số tiền nhỏ',},
    {messageId: 'SMS00803M009F', messageContent: 'Phí thiệt hại do chậm trễ',},
    {messageId: 'SMS00803M010F', messageContent: 'Phí xử lý yêu cầu thanh toán lại',},
    {messageId: 'SMS00803M011F', messageContent: 'Phí khai báo\r\n(phí chuẩn bị hồ sơ)',},
    {messageId: 'SMS00803M012F', messageContent: 'Phí khai báo\r\n(phí gửi thư)',},
    {messageId: 'SMS00803M013F', messageContent: 'Xuất mã vạch thanh toán tại cửa hàng tiện lợi',},
    {messageId: 'SMS00803M014F', messageContent: 'Đến màn hình chuyển khoản tiền thuê nhà',},
    {messageId: 'SMS00803M015F', messageContent: 'Quay lại trình đơn',},

    // ====================================================
    // SMS009_氏名変更登録
    // ====================================================
    // メッセージ（INFO）
    {messageId: 'SMS00901M001I', messageContent: '{1} {2}処理を開始しました。',},
    {messageId: 'SMS00901M002I', messageContent: '{1} {2}処理を完了しました。',},
    {messageId: 'SMS00901M003I', messageContent: '{1} {2}DB処理を開始しました。',},
    {messageId: 'SMS00901M004I', messageContent: '{1} {2}DB処理が完了しました。',},
    {messageId: 'SMS00901M005I', messageContent: '{1} {2}ボタンが押下されました。',},
    // メッセージ（ERROR）
    {messageId: 'SMS00901M001E', messageContent: '{1} {2}処理でエラーが発生しました。',},
    {messageId: 'SMS00901M002E', messageContent: '{1} {2}ボタン処理でエラーが発生しました。',},
    {messageId: 'SMS00901M003E', messageContent: '{1} DB処理に失敗しました。',},
    {messageId: 'SMS00901M004E', messageContent: '{1} DB処理でエラーが発生しました。',},
    {messageId: 'SMS00901M005E', messageContent: 'ログイン情報の取得に失敗しました。',},
    // タイトル名
    {messageId: 'SMS00901M001T', messageContent: '氏名変更登録',},
    {messageId: 'SMS00902M001T', messageContent: 'Name Change Registration',},
    {messageId: 'SMS00903M001T', messageContent: 'Đăng ký đổi tên',},
    // 画面文言（日本語）
    {messageId: 'SMS00901M001F', messageContent: '{1}　{2} 様',},
    {messageId: 'SMS00901M002F', messageContent: '姓',},
    {messageId: 'SMS00901M003F', messageContent: '名',},
    {messageId: 'SMS00901M004F', messageContent: 'セイ',},
    {messageId: 'SMS00901M005F', messageContent: 'メイ',},
    {messageId: 'SMS00901M006F', messageContent: '生年月日 {1}年{2}月{3}日',},
    {messageId: 'SMS00901M007F', messageContent: '※氏名の更新・反映にはお時間を要する場合がございます。',},
    {messageId: 'SMS00901M008F', messageContent: '※ご注意',},
    {messageId: 'SMS00901M009F', messageContent: 'この画面でご契約者の変更はお受けできません。',},
    {messageId: 'SMS00901M010F', messageContent: '変更のご相談は、下記カスタマーセンターまでお電話ください。',},
    {messageId: 'SMS00901M011F', messageContent: 'カスタマーセンター',},
    {messageId: 'SMS00901M012F', messageContent: '送信',},
    {messageId: 'SMS00901M013F', messageContent: 'メニューへ戻る',},
    // 画面文言（英語）
    {messageId: 'SMS00902M001F', messageContent: 'Dear {1}　{2}',},
    {messageId: 'SMS00902M002F', messageContent: 'Surname',},
    {messageId: 'SMS00902M003F', messageContent: 'First name',},
    {messageId: 'SMS00902M004F', messageContent: 'Surname',},
    {messageId: 'SMS00902M005F', messageContent: 'First name',},
    {messageId: 'SMS00902M006F', messageContent: 'Date of birth {2}/ {3}, {1}',},
    {messageId: 'SMS00902M007F', messageContent: '*It may take some time to update and reflect your name.',},
    {messageId: 'SMS00902M008F', messageContent: '*Precaution',},
    {messageId: 'SMS00902M009F', messageContent: 'You cannot change the party to the contract on this screen.',},
    {messageId: 'SMS00902M010F', messageContent: 'To discuss changes, please call the customer center below.',},
    {messageId: 'SMS00902M011F', messageContent: 'Customer Center',},
    {messageId: 'SMS00902M012F', messageContent: 'Send',},
    {messageId: 'SMS00902M013F', messageContent: 'Return to menu',},
    // 画面文言（ベトナム語）
    {messageId: 'SMS00903M001F', messageContent: 'Khách hàng {1}　{2}',},
    {messageId: 'SMS00903M002F', messageContent: '(Kanji) Họ',},
    {messageId: 'SMS00903M003F', messageContent: 'Tên',},
    {messageId: 'SMS00903M004F', messageContent: '(Katakana) Họ',},
    {messageId: 'SMS00903M005F', messageContent: 'Tên',},
    {messageId: 'SMS00903M006F', messageContent: 'Ngày tháng năm sinh ngày{3} tháng{2} năm{1}',},
    {messageId: 'SMS00903M007F', messageContent: '*Có thể mất chút thời gian để cập nhật và phản ánh tên của bạn.',},
    {messageId: 'SMS00903M008F', messageContent: '*Lưu ý',},
    {messageId: 'SMS00903M009F', messageContent: 'Chúng tôi không thể tiếp nhận yêu cầu thay đổi người ký hợp đồng tại màn hình này.',},
    {messageId: 'SMS00903M010F', messageContent: 'Để hỏi về những thay đổi, vui lòng gọi đến trung tâm khách hàng bên dưới.',},
    {messageId: 'SMS00903M011F', messageContent: 'Trung tâm khách hàng',},
    {messageId: 'SMS00903M012F', messageContent: 'gửi',},
    {messageId: 'SMS00903M013F', messageContent: 'Quay lại trình đơn',},

    // ====================================================
    // SMS010_手続完了
    // ====================================================
    // メッセージ（INFO）
    {messageId: 'SMS01001M001I', messageContent: '{1} {2}処理を開始しました。',},
    {messageId: 'SMS01001M002I', messageContent: '{1} {2}処理を完了しました。',},
    {messageId: 'SMS01001M003I', messageContent: '{1} {2}ボタンが押下されました。',},
    // メッセージ（ERROR）
    {messageId: 'SMS01001M001E', messageContent: '{1} {2}処理でエラーが発生しました。',},
    {messageId: 'SMS01001M002E', messageContent: '{1} {2}ボタン処理でエラーが発生しました。',},
    {messageId: 'SMS01001M003E', messageContent: 'ログイン情報の取得に失敗しました。',},
    // タイトル名
    {messageId: 'SMS01001M001T', messageContent: '',},
    {messageId: 'SMS01002M001T', messageContent: '',},
    {messageId: 'SMS01003M001T', messageContent: '',},
    // 画面文言（日本語）
    {messageId: 'SMS01001M001F', messageContent: '登録完了',},
    {messageId: 'SMS01001M002F', messageContent: 'お手続きが完了しました。',},
    {messageId: 'SMS01001M003F', messageContent: 'メニューへ戻る',},
    // 画面文言（英語）
    {messageId: 'SMS01002M001F', messageContent: 'Registration Complete',},
    {messageId: 'SMS01002M002F', messageContent: 'The process has been completed.',},
    {messageId: 'SMS01002M003F', messageContent: 'Return to menu',},
    // 画面文言（ベトナム語）
    {messageId: 'SMS01003M001F', messageContent: 'Hoàn tất đăng ký',},
    {messageId: 'SMS01003M002F', messageContent: 'Thủ tục đã hoàn tất',},
    {messageId: 'SMS01003M003F', messageContent: 'Quay lại trình đơn',},

    // ====================================================
    // SMS011_エラー画面
    // ====================================================
    // メッセージ（INFO）
    {messageId: 'SMS01101M001I', messageContent: '{1} {2}処理を開始しました。',},
    {messageId: 'SMS01101M002I', messageContent: '{1} {2}処理を完了しました。',},
    {messageId: 'SMS01101M003I', messageContent: '{1} {2}ボタンが押下されました。',},
    {messageId: 'SMS01101M004I', messageContent: '{1} エラーメッセージID：{2}',},
    // メッセージ（ERROR）
    {messageId: 'SMS01101M001E', messageContent: '{1} {2}処理でエラーが発生しました。',},
    {messageId: 'SMS01101M002E', messageContent: '{1} {2}ボタン処理でエラーが発生しました。',},
    {messageId: 'SMS01101M003E', messageContent: 'POSTパラメータの取得に失敗しました。',},
    // タイトル名
    {messageId: 'SMS01101M001T', messageContent: '',},
    {messageId: 'SMS01102M001T', messageContent: '',},
    {messageId: 'SMS01103M001T', messageContent: '',},
    // 画面文言（日本語）
    {messageId: 'SMS01101M001F', messageContent: '担当部署：',},
    {messageId: 'SMS01101M002F', messageContent: 'メニューへ戻る',},
    // 画面文言（英語）
    {messageId: 'SMS01102M001F', messageContent: 'Department in charge：',},
    {messageId: 'SMS01102M002F', messageContent: 'Return to menu',},
    // 画面文言（ベトナム語）
    {messageId: 'SMS01103M001F', messageContent: 'Phòng ban phụ trách：',},
    {messageId: 'SMS01103M002F', messageContent: 'Quay lại trình đơn',},


    // ====================================================
    // ICS 既存メッセージ
    // ====================================================
    {messageId: 'CSS01999M001E', messageContent: 'システムエラーが発生しました。画面を開きなおして、処理を再実行してください。連続してエラーが発生する場合は、システム管理部門へお問い合わせください。',},
    {messageId: 'CSS01999M002E', messageContent: 'DBに接続時に、エラーが発生しました。',},
    {messageId: 'CSS01999M003E', messageContent: 'SQLが正しくありません。',},
    {messageId: 'CSS01999M004E', messageContent: '現在、データが他の処理により更新されています、しばらく経ってから再度実行してください。',},
    {messageId: 'CSS01999M005E', messageContent: 'PDFへの変換処理に失敗しました。',},
    {messageId: 'CSS01999M006E', messageContent: 'ログの出力に失敗しました。',},
    {messageId: 'CSS01999M007E', messageContent: '予期せぬエラーが発生しました。',},
    {messageId: 'CSS01999M008E', messageContent: 'ICSLogInfoFilterフィルター例外です。',},
    {messageId: 'CSS01999M009E', messageContent: '利用権限がありません。',},
    {messageId: 'CSS01999M010E', messageContent: 'S3へファイルを保存する際に、エラーが発生しました。',},
    {messageId: 'CSS01999M011E', messageContent: 'S3のファイルを削除する際に、エラーが発生しました。',},
    {messageId: 'CSS01999M012E', messageContent: 'ユーザーのJWTトークンを生成する際に、エラーが発生しました。',},
    {messageId: 'CSS01999M013E', messageContent: '新規ウィンドウの起動に失敗しました。ポップアップグロックが設定されていないかご確認ください。',},
    {messageId: 'CSS01999M014E', messageContent: 'エクセルファイルを開く際に、エラーが発生しました。',},
    {messageId: 'CSS01999M015E', messageContent: 'エクセルファイルを保存する際に、エラーが発生しました。',},
    {messageId: 'CSS01999M016E', messageContent: 'ワードのテンプレートファイルを開く際に、エラーが発生しました。',},
    {messageId: 'CSS01999M018E', messageContent: 'コピー元とコピー先の書式は無効化されています。',},
    {messageId: 'CSS01999M019E', messageContent: 'オブジェクトのプロパティ名を取得する時に例外が発生しました。',},
    {messageId: 'CSS01999M020E', messageContent: 'Beanクラスに名前が指定されていません。',},
    {messageId: 'CSS01999M021E', messageContent: 'アクセストークンの生成に失敗しました。',},
    {messageId: 'CSS01999M024E', messageContent: 'ログインIDが存在しません。',},
    {messageId: 'CSS01999M025E', messageContent: '新郵便番号を入力してください。',},
    {messageId: 'CSS01999M026E', messageContent: '他のユーザーにより情報が更新されています。',},
    {messageId: 'CSS01999M027E', messageContent: 'Qrcodeを生成する際に、変換できないエラーを生成します。',},
    {messageId: 'CSS01999M028W', messageContent: '短時間に連続してエラーが発生したため、ログ機能を停止します。',},
    {messageId: 'CSS01999M030I', messageContent: 'Tokenリフレッシュ処理を実行します。',},
    {messageId: 'CSS01999M031E', messageContent: 'Tokenリフレッシュ処理中に再度401エラーが発生しました。',},
    {messageId: 'CSS01999M032W', messageContent: '画面遷移URLのパスに対する複数の画面定義(app-routingのScreenDefinitions)が検出されました。対象パス:{1}',},
    {messageId: 'CSS01999M033E', messageContent: '画面遷移URLのパスが画面定義に存在しません。対象パス:{1}',},
    {messageId: 'CSS01999M034I', messageContent: 'ログインが成功しました。',},
    {messageId: 'CSS01999M035I', messageContent: 'Access TokenとRefresh Tokenを再設定します。',},
    {messageId: 'CSS01999M036E', messageContent: '子画面からのコールバックメソッド実行時にエラーが発生しました。',},
    {messageId: 'CSS01999M037E', messageContent: 'システムエラーが発生しました。和暦年に0以下が指定されています。システム管理部門にお問い合わせください。',},
    {messageId: 'CSS01999M038E', messageContent: '親画面のメソッドの実行に失敗しました。',},
    {messageId: 'CSS01999M039I', messageContent: '定義されていないScreen IDで画面遷移をしました。ScreenID:{1}',},
    {messageId: 'CSS01999M041E', messageContent: '認証トークンがありません。',},
    {messageId: 'CSS01999M042E', messageContent: '認証トークンが正しくありません。',},
    {messageId: 'CSS01999M043E', messageContent: 'ユーザー情報がありません。',},
    {messageId: 'CSS01999M044E', messageContent: '接続情報の有効期限が切れています。もう一度接続をやり直してください。',},
    {messageId: 'CSS01999M045E', messageContent: 'リフレッシュトークンの更新に失敗しました。',},
    {messageId: 'CSS01999M046E', messageContent: 'JWTトークンのバリデートで例外が発生しました。',},
    {messageId: 'CSS01999M047E', messageContent: 'DBアクセスでエラーが発生しました。',},
    {messageId: 'CSS01999M048E', messageContent: 'エンコーディングの変換を行う際に、例外エラーが発生しました。',},
    {messageId: 'CSS01999M049E', messageContent: 'StringをBase64に変換する。例外エラーが発生した。',},
    {messageId: 'CSS01999M050E', messageContent: 'フォーマットは必須項目です。',},
    {messageId: 'CSS01999M051E', messageContent: '入力値が不正です。例外エラーが発生しました。',},
    {messageId: 'CSS01999M052E', messageContent: '日付が正しくありません。',},
    {messageId: 'CSS01999M053E', messageContent: '引数がブランクです。例外エラーが発生しました。',},
    {messageId: 'CSS01999M055E', messageContent: 'Base64の読み込み時にエラーが発生しました。',},
    {messageId: 'CSS01999M056E', messageContent: 'Base64の書き込み時にエラーが発生しました。',},
    {messageId: 'CSS01999M057E', messageContent: 'アクセストークンの認証に失敗しました。',},
    {messageId: 'CSS01999M058E', messageContent: '{1}',},
    {messageId: 'CSS01999M059I', messageContent: '{1}',},
    {messageId: 'CSS01999M059I', messageContent: '{1}',},
    {messageId: 'CSS01999M060E', messageContent: '発行したSQLは指定時間({1} mSec)を経過したため、タイムアウトになりました',},
    {messageId: 'CSS01999M061I', messageContent: 'メソッド開始: class={1}, method={2}, params={3}',},
    {messageId: 'CSS01999M062I', messageContent: 'メソッド終了: class={1}, method={2}, return={3}',},
    {messageId: 'CSS01999M063E', messageContent: 'DBのセッション接続が開始されていません。',},
    {messageId: 'CSS01999M064E', messageContent: 'DBのセッション接続が時間切れになりました、再度最初から画面操作を行ってください。',},
    {messageId: 'CSS01999M065E', messageContent: '非同期の処理状態が取得できません、AsyncThreadID={1}',},
    {messageId: 'CSS01999M066I', messageContent: 'APIリクエスト={1}',},
    {messageId: 'CSS01999M067I', messageContent: 'APIレスポンス={1}',},
    {messageId: 'CSS01999M068I', messageContent: 'APIレスポンスHttpStatus={1}',},
    {messageId: 'CSS01999M069E', messageContent: 'メッセージIDが設定されていない例外がスローされました。',},
    {messageId: 'CSS01999M070E', messageContent: 'アクセストークンがタイムアウトとなりました。',},
    {messageId: 'CSS01999M071I', messageContent: 'ファイル出力に成功しました。ファイル名:{1}',},
    {messageId: 'CSS01999M072I', messageContent: 'ファイル出力に失敗しました。ファイル名:{1}',},
    {messageId: 'CSS01999M073I', messageContent: 'ログイン有効期限切れエラー',},
    {messageId: 'CSS01999M501E', messageContent: '数値または値のエラー: 文字列バッファが小さすぎます',},

    {messageId: 'CSS02019M001E', messageContent: '解析中 "{1}" - {x,y} が無効です。x が y よりも大きい値です。',},

    {messageId: 'CSS02999M001E', messageContent: '{1}バイト以内で入力してください。',},
    {messageId: 'CSS02999M002E', messageContent: '全角カナ（スペース以外）のみが許可されています。',},
    {messageId: 'CSS02999M005E', messageContent: '{1}以上{2}以下で入力してください。',},
    {messageId: 'CSS02999M006E', messageContent: '不正な文字が入力されています。',},
    {messageId: 'CSS02999M007E', messageContent: '整数部{1}桁、小数部{2}桁の実数で入力してください。',},
    {messageId: 'CSS02999M008E', messageContent: 'ApplicationConfigに{1}の値が記載されていないか、不正な値が記載されています。',},
    {messageId: 'CSS02999M011E', messageContent: '新郵便番号には、半角数字7桁で入力してください。',},
    {messageId: 'CSS02999M012E', messageContent: '整理番号は、半角数字1～9,半角大文字A～Z,半角ハイフンが使用できる文字です。',},
    {messageId: 'CSS02999M013E', messageContent: '半角文字を最大13文字記載します。',},
    {messageId: 'CSS02999M014E', messageContent: '入力内容に誤りがあります。',},
    {messageId: 'CSS02999M015E', messageContent: '必須入力です。',},
    {messageId: 'CSS02999M016E', messageContent: '{1}以上の数値を入力してください。',},
    {messageId: 'CSS02999M017E', messageContent: '{1}以下の数値を入力してください。',},
    {messageId: 'CSS02999M018E', messageContent: 'Emailの形式が正しくありません。',},
    {messageId: 'CSS02999M019E', messageContent: '{1}桁以上にする必要があります。',},
    {messageId: 'CSS02999M020E', messageContent: '{1}桁以下にする必要があります。',},
    {messageId: 'CSS02999M021E', messageContent: '入力形式が正しくありません。',},
    {messageId: 'CSS02999M022E', messageContent: '半角アルファベットのみ入力可能です。',},
    {messageId: 'CSS02999M023E', messageContent: '半角数値のみ入力可能です。',},
    {messageId: 'CSS02999M024E', messageContent: '半角英数のみ入力可能です。',},
    {messageId: 'CSS02999M025E', messageContent: '全角文字のみ入力可能です。',},
    {messageId: 'CSS02999M026E', messageContent: '半角カタカナのみ入力可能です。',},
    {messageId: 'CSS02999M027E', messageContent: '全角ひらがなのみ入力可能です。',},
    {messageId: 'CSS02999M028E', messageContent: '全角カタカナのみ入力可能です。',},
    {messageId: 'CSS02999M029E', messageContent: 'Shift_JISでの存在チェックの際に、エラーが発生しました。',},
    {messageId: 'CSS02999M030E', messageContent: 'Shift_JISでの存在チェック(全角のみ)の際に、エラーが発生しました。',},
    {messageId: 'CSS02999M031E', messageContent: '半角文字と小数点(桁数チェック付)の際に、エラーが発生しました。',},
    {messageId: 'CSS02999M032E', messageContent: '承認番号の形式に誤りがあります。',},
    {messageId: 'CSS02999M033E', messageContent: '運転免許証番号の形式に誤りがあります。',},
    {messageId: 'CSS02999M034E', messageContent: 'MP契約番号の確認を行う際に、エラーが発生しました。',},
    {messageId: 'CSS02999M035E', messageContent: '文字列の作成を行う際に、エラーが発生しました。',},
    {messageId: 'CSS02999M036E', messageContent: '日付範囲チェックの際に、エラーが発生しました。',},
    {messageId: 'CSS02999M038E', messageContent: '日付のFrom～Toチェックを行う際に、エラーが発生しました。',},
    {messageId: 'CSS02999M039E', messageContent: '全角アルファベットと空白チェックを行う際に、エラーが発生しました。',},
    {messageId: 'CSS02999M040E', messageContent: '不正な値が設定されています。',},
    {messageId: 'CSS02999M041E', messageContent: '郵便番号の形式が正しくありません。',},
    {messageId: 'CSS02999M042E', messageContent: '{1}桁の整数で入力してください。',},
    {messageId: 'CSS02999M043E', messageContent: '{1}桁以上、{2}桁以下の整数で入力してください。',},
    {messageId: 'CSS02999M044E', messageContent: '電話番号の形式が正しくありません。',},
    {messageId: 'CSS02999M045E', messageContent: '携帯電話番号の形式が正しくありません。',},
    {messageId: 'CSS02999M046E', messageContent: '{1}桁以上、{2}桁以下の全角カナのみが許可されています。',},
    {messageId: 'CSS02999M047E', messageContent: '{1}桁以上、{2}桁以下の全角文字（スペース以外）のみが許可されています。',},
    {messageId: 'CSS02999M048E', messageContent: '{1}桁以上、{2}桁以下の全角カナと（）のみが許可されています。',},
    {messageId: 'CSS02999M049E', messageContent: '{1}桁以上、{2}桁以下の全角文字と記号のみが許可されています。',},
    {messageId: 'CSS02999M050E', messageContent: '{1}桁以上、{2}桁以下の全角文字のみが許可されています。',},
    {messageId: 'CSS02999M051E', messageContent: '{1}桁以上、{2}桁以下の全角文字と記号のみが許可されています。',},
    {messageId: 'CSS02999M052E', messageContent: '全角文字（スペース以外）と記号のみが許可されています。',},
    {messageId: 'CSS02999M053E', messageContent: '英字(大文字)、数字、「-(ハイフン)」のみが許可されています。',},
    {messageId: 'CSS02999M054E', messageContent: 'ダブルクォーテーションは許可されていません。',},
    {messageId: 'CSS02999M055E', messageContent: '整数で入力してください。',},
    {messageId: 'CSS02999M056E', messageContent: '半角数字と小数点のみが許可されています。',},
    {messageId: 'CSS02999M057E', messageContent: '半角と記号のみが許可されています。',},
    {messageId: 'CSS02999M058E', messageContent: '全角文字（スペース以外）のみが許可されています。',},
    {messageId: 'CSS02999M059E', messageContent: '全角文字と記号（dot ．以外）のみが許可されています。',},
    {messageId: 'CSS02999M060E', messageContent: '全角文字と記号のみが許可されています。',},
    {messageId: 'CSS02999M061E', messageContent: '全角文字と記号（スペース以外）のみが許可されています。',},
    {messageId: 'CSS02999M062E', messageContent: '全角カナと（）のみが許可されています。',},
    {messageId: 'CSS02999M063E', messageContent: '半角数字（マイナス入力可）を入力してください。',},
    {messageId: 'CSS02999M064E', messageContent: '全角カナと空白のみが許可されています。',},
    {messageId: 'CSS02999M065E', messageContent: '全角空白が１文字のみが許可されています。',},
    {messageId: 'CSS02999M066E', messageContent: 'メニュー番号の形式が正しくありません。',},
    {messageId: 'CSS02999M067E', messageContent: '契約受付番号の形式が正しくありません。',},
    {messageId: 'CSS02999M068E', messageContent: '{1}桁の半角のみ入力可能です。',},
    {messageId: 'CSS02999M069E', messageContent: '占有面積の形式（xxx又はxxx.xx）が正しくありません。',},
    {messageId: 'CSS02999M070E', messageContent: '代理店手数料の形式（xxx又はxxx.xx）が正しくありません。',},
    {messageId: 'CSS02999M071E', messageContent: '0〜100の数値のみが許可されています。',},
    {messageId: 'CSS02999M072E', messageContent: 'YYYYMMDD形式の日付のみが許可されています。',},
    {messageId: 'CSS02999M073E', messageContent: 'YYYYMM形式の日付のみが許可されています。',},
    {messageId: 'CSS02999M074E', messageContent: 'YYYYMMDDhhmmss形式の日付のみが許可されています。',},
    {messageId: 'CSS02999M075E', messageContent: '全角アルファベットと空白のみが許可されています。',},
    {messageId: 'CSS02999M076E', messageContent: '日付の開始日より終了日の方が後になるように設定してください。',},
    {messageId: 'CSS02999M077E', messageContent: '半角文字のみが許可されています。',},
    {messageId: 'CSS02999M078E', messageContent: '画像の結合処理で、例外が発生しました。',},
    {messageId: 'CSS02999M079E', messageContent: '引数の有効性チェックを行う際に、エラーが発生しました。',},
    {messageId: 'CSS02999M080E', messageContent: '概算率のチェックを行う際に、エラーが発生しました。',},
    {messageId: 'CSS02999M081E', messageContent: '数値フォーマットの文字列である必要があります。',},
    {messageId: 'CSS02999M082E', messageContent: '入力値の文字数を確認してください。',},
    {messageId: 'CSS02999M083E', messageContent: '正しい桁数の数値を入力してください。',},
    {messageId: 'CSS02999M084E', messageContent: '正しい桁数の数値（マイナスを含む）を入力してください。',},
    {messageId: 'CSS02999M085E', messageContent: '正しい桁数の数値（小数を含む）を入力してください。',},
    {messageId: 'CSS02999M086E', messageContent: '正しい桁数の半角文字を入力してください。',},
    {messageId: 'CSS02999M087E', messageContent: '正しい桁数の全角文字（スペース以外）を入力してください。',},
    {messageId: 'CSS02999M088E', messageContent: '正しい桁数の全角文字を入力してください。',},
    {messageId: 'CSS02999M089E', messageContent: '正しい桁数の全角文字、または記号を入力してください。',},
    {messageId: 'CSS02999M090E', messageContent: '正しい桁数の半角カナ文字を入力してください。',},
    {messageId: 'CSS02999M091E', messageContent: '正しい桁数の全角カナ文字を入力してください。',},
    {messageId: 'CSS02999M092E', messageContent: '正しい桁数の全角カナ、または（）を入力してください。',},
    {messageId: 'CSS02999M093E', messageContent: '正しい桁数の全角カナ、またはスペースを入力してください。',},
    {messageId: 'CSS02999M094E', messageContent: '正しい桁数の全角アルファベット、またはスペースを入力してください。',},
    {messageId: 'CSS02999M096E', messageContent: '{1}桁以上、{2}桁以下の全角文字と記号のみが許可されています。',},
    {messageId: 'CSS02999M097E', messageContent: '全角文字（スペース以外）と記号のみが許可されています。',},
    {messageId: 'CSS02999M099E', messageContent: '正しい桁数の全角文字、またはピリオドを入力してください',},
    {messageId: 'CSS02999M100E', messageContent: '正しい桁数の半角文字、またはハイフンを入力してください。',},
    {messageId: 'CSS02999M101E', messageContent: '半角数字（マイナス・小数入力可）を入力してください。',},
    {messageId: 'CSS02999M102E', messageContent: '最小値より最大値が大きい数値となるように設定してください。',},
    {messageId: 'CSS02999M103E', messageContent: '選択ファイルの合計サイズが上限値{1}バイトを超過しました。\r\n{1}バイト以内で入力してください。',},
    {messageId: 'CSS02999M104E', messageContent: '文字数制限により、入力された文字を削除しました。',},
    {messageId: 'CSS02999M105E', messageContent: '入力された年はうるう年ではありません。',},
    {messageId: 'CSS02999M106E', messageContent: '{1}桁以上の整数で入力してください。',},
    {messageId: 'CSS02999M107E', messageContent: '27日以外指定できません。',},
    {messageId: 'CSS02999M108E', messageContent: 'YYYY形式の日付のみが許可されています。',},
    {messageId: 'CSS02999M109E', messageContent: 'MM形式の日付のみが許可されています。',},
    {messageId: 'CSS02999M110E', messageContent: 'DD形式の日付のみが許可されています。',},
    {messageId: 'CSS02999M111E', messageContent: '日付を入力してください。',},
    {messageId: 'CSS02999M112I', messageContent: '{1}ボタン押下されました。',},

    {messageId: 'CSM01999M001I', messageContent: '検索結果が0件です。',},
    {messageId: 'CSM01999M002I', messageContent: '更新が完了しました。',},
    {messageId: 'CSM01999M003I', messageContent: '入力チェック：OK',},
    {messageId: 'CSM01999M004I', messageContent: '入力チェック：NG',},
    {messageId: 'CSM01999M005I', messageContent: '{1}キーが押されました。',},
    {messageId: 'CSM01999M006I', messageContent: '{1}ボタン押下されました。',},
    {messageId: 'CSM01999M007I', messageContent: '{1}ボタン押下処理を開始しました。',},
    {messageId: 'CSM01999M008I', messageContent: '{1}ボタン押下処理を終了しました。',},
    {messageId: 'CSM01999M009I', messageContent: '{1}処理が終了しました。',},
    {messageId: 'CSM01999M010I', messageContent: '{1}処理が開始しました。',},
    {messageId: 'CSM01999M011I', messageContent: '{1}が変更されました。',},
    {messageId: 'CSM01999M014I', messageContent: '{1}を取得しました。',},
    {messageId: 'CSM01999M020I', messageContent: '{1}が完了しました。',},
    {messageId: 'CSM01999M021I', messageContent: 'コミットしました。',},
    {messageId: 'CSM01999M024I', messageContent: 'SPを実行しました。',},
    {messageId: 'CSM01999M036I', messageContent: 'DB処理に成功しました。',},
    {messageId: 'CSM01999M050I', messageContent: '検索条件',},
    {messageId: 'CSM01999M052I', messageContent: 'ロールバックしました。',},
    {messageId: 'CSM01999M083I', messageContent: 'データグリッドがダブルクリックされました。',},
    {messageId: 'CSM01999M084I', messageContent: 'データグリッドがクリックされました。',},
    {messageId: 'CSM01999M098I', messageContent: '総件数：{1}',},
    {messageId: 'CSM01999M107I', messageContent: '該当するデータはありませんでした。',},
    {messageId: 'CSM01999M124I', messageContent: '明細を作成しますか？(Y/N)',},
    {messageId: 'CSM01999M140I', messageContent: '上記の内容で引当しますか？(Y/N)',},
    {messageId: 'CSM01999M149E', messageContent: '契約情報の取得に失敗しました。',},
    {messageId: 'CSM01999M152E', messageContent: '設定ファイルの読込に失敗しました。',},
    {messageId: 'CSM01999M165I', messageContent: '画面名：{1}',},
    {messageId: 'CSM01999M166I', messageContent: '「Y」キーが押下されたため、DB変更処理を実施します。',},
    {messageId: 'CSM01999M167I', messageContent: '「N」キーが押下されたため、DB変更処理を中止します。',},
    {messageId: 'CSM01999M168I', messageContent: '画面を閉じます。',},
    {messageId: 'CSM01999M169E', messageContent: 'データの取得に失敗しました。 {1}',},
    {messageId: 'CSM01999M171I', messageContent: 'ページ戻りを行います。',},
    {messageId: 'CSM01999M172I', messageContent: 'ページ送りを行います。',},
    {messageId: 'CSM01999M173E', messageContent: 'xmlファイルの読込に失敗しました。',},
    {messageId: 'CSM01999M174I', messageContent: '画面を閉じてもよろしいですか？',},
    {messageId: 'CSM01999M175E', messageContent: 'DB処理に失敗しました。',},
    {messageId: 'CSM01999M176E', messageContent: '値が有効な範囲にありません。',},
    {messageId: 'CSM01999M177E', messageContent: '必要なタグの読み込みに失敗しました。',},
    {messageId: 'CSM01999M178E', messageContent: 'コミットに失敗しました。',},
    {messageId: 'CSM01999M179E', messageContent: '登録処理に失敗しました。',},
    {messageId: 'CSM01999M180E', messageContent: 'no data found:契約情報取得中にエラーが発生しました。',},
    {messageId: 'CSM01999M181E', messageContent: '引数に不正な値が設定されています。',},
    {messageId: 'CSM01999M182I', messageContent: '契約情報ID：{1}',},
    {messageId: 'CSM01999M183E', messageContent: '登録に失敗しました。',},
    {messageId: 'CSM01999M184E', messageContent: '削除されていない承認情報内で、承認番号が重複しています。',},
    {messageId: 'CSM01999M185E', messageContent: '対象年月存在チェックエラーです。',},
    {messageId: 'CSM01999M186E', messageContent: '承認番号が間違っています。再度入力ください。',},
    {messageId: 'CSM01999M187E', messageContent: '対象の口座照会情報が存在しませんでした。',},
    {messageId: 'CSM01999M188E', messageContent: '同じKISSコードが既に存在します。',},
    {messageId: 'CSM01999M189E', messageContent: 'リクルート口座情報の更新に失敗しました。',},
    {messageId: 'CSM01999M190E', messageContent: '指定された不動産会社には支店が存在しません。',},
    {messageId: 'CSM01999M191E', messageContent: '指定された契約情報IDに対する契約情報が存在しません。',},
    {messageId: 'CSM01999M192E', messageContent: 'RECRUIT口座の更新情報が不正の為、RECRUIT口座の更新に失敗しました。',},
    {messageId: 'CSM01999M193I', messageContent: '<本検索条件>',},
    {messageId: 'CSM01999M194E', messageContent: '変動費内訳レコードの登録に失敗しました。',},
    {messageId: 'CSM01999M195E', messageContent: '出金方法が特定できません。',},
    {messageId: 'CSM01999M196E', messageContent: '引数に不正な値が設定されています。{1}',},
    {messageId: 'CSM01999M197E', messageContent: 'XMLから読み込んだ銀行コードが設定されていません。',},
    {messageId: 'CSM01999M198E', messageContent: '不正な収納会社が設定されています。',},
    {messageId: 'CSM01999M199E', messageContent: '{1}件処理されました。{2}',},
    {messageId: 'CSM01999M200E', messageContent: '承認番号、家賃年月が正しくない値のため初期入力値のセットは行いませんでした。',},
    {messageId: 'CSM01999M201E', messageContent: '指定された契約に対する支払状況が1件も存在しません。',},
    {messageId: 'CSM01999M202E', messageContent: '引当処理に失敗しました。承認番号が正しくないか、引当可能な支払状況が存在しません。',},
    {messageId: 'CSM01999M203E', messageContent: '複数件データが該当しました。',},
    {messageId: 'CSM01999M204E', messageContent: '口座情報の読み込みに失敗しました。',},
    {messageId: 'CSM01999M205E', messageContent: '取得した更新対象レコード件数が不正です。',},
    {messageId: 'CSM01999M206E', messageContent: '更新対象レコードを取得できません。',},
    {messageId: 'CSM01999M207E', messageContent: '差額を反映した支払手数料(税込み)がマイナス値になりました。',},
    {messageId: 'CSM01999M208E', messageContent: '差額を反映した月額合計金額（収納）がマイナス値になりました。',},
    {messageId: 'CSM01999M209E', messageContent: '差額を反映した月額合計金額（出納）がマイナス値になりました。',},
    {messageId: 'CSM01999M210E', messageContent: '備考が2000文字を超過しました。',},
    {messageId: 'CSM01999M211E', messageContent: '変更情報が2000文字を超過しました。',},
    {messageId: 'CSM01999M212E', messageContent: 'シーケンスの桁数が規定数を超えています。',},
    {messageId: 'CSM01999M213E', messageContent: '採番に失敗しました。',},
    {messageId: 'CSM01999M214E', messageContent: '選択したレコードに対応する、振込(出金)依頼情報が存在しません。',},
    {messageId: 'CSM01999M215E', messageContent: '該当レコードが存在しません。',},
    {messageId: 'CSM01999M216E', messageContent: '既に登録されている対応区分と家賃年月です。登録できません。',},
    {messageId: 'CSM01999M217E', messageContent: '暗号化鍵が見つかりません。',},
    {messageId: 'CSM01999M218E', messageContent: '暗号化鍵が複数件見つかりました。',},
    {messageId: 'CSM01999M219E', messageContent: '前回バッチ実行日時の取得に失敗しました。',},
    {messageId: 'CSM01999M220E', messageContent: '入力した承認番号に紐付く情報が存在しないため、個別ダブルチェックを行うことが出来ません。',},
    {messageId: 'CSM01999M221E', messageContent: 'ロックに失敗しました。',},
    {messageId: 'CSM01999M222E', messageContent: '更新に失敗ました。',},
    {messageId: 'CSM01999M223E', messageContent: '引数取得に失敗しました。',},
    {messageId: 'CSM01999M224E', messageContent: '{1}中にエラーが発生しました。',},
    {messageId: 'CSM01999M225E', messageContent: '書式コードが未入力です。',},
    {messageId: 'CSM01999M226E', messageContent: 'リクルート口座IDが未入力です。',},
    {messageId: 'CSM01999M227E', messageContent: '振込先口座が同一で、{1}{2}明細の送付先が異なります。',},
    {messageId: 'CSM01999M228E', messageContent: '選択したレコードに対応する、{1}{2}振込(出金)依頼情報が存在しません。',},
    {messageId: 'CSM01999M229I', messageContent: '明細を作成しました。',},
    {messageId: 'CSM01999M230E', messageContent: '金額が不正です。',},
    {messageId: 'CSM01999M231E', messageContent: '備考の桁あふれが発生しました。',},
    {messageId: 'CSM01999M232I', messageContent: '登録処理に成功しました。',},
    {messageId: 'CSM01999M233E', messageContent: '明細作成処理に失敗しました。',},
    {messageId: 'CSM01999M234I', messageContent: '■データ取得に失敗しました。',},
    {messageId: 'CSM01999M235E', messageContent: '■データ取得に失敗しました。',},
    {messageId: 'CSM01999M238E', messageContent: '留守電の吹込み処理に失敗しました。',},
    {messageId: 'CSM01999M239E', messageContent: 'データが見つかりません。{1}',},
    {messageId: 'CSM01999M242I', messageContent: 'トランザクションをコミットしました。',},
    {messageId: 'CSM01999M243E', messageContent: '値をNullにすることはできません。',},
    {messageId: 'CSM01999M260E', messageContent: '値が有効な範囲にありません。',},
    {messageId: 'CSM01999M261E', messageContent: '指定された引数は、有効な値の範囲内にありません。',},
    {messageId: 'CSM01999M262E', messageContent: 'ディスク上に存在しないパスにアクセスしようとしました。',},
    {messageId: 'CSM01999M263E', messageContent: '指定されたファイルが見つかりません。',},
    {messageId: 'CSM01999M264E', messageContent: '種類 「System.Exception」 の例外がスローされました。',},
    {messageId: 'CSM01999M265E', messageContent: '識別された項目のうち 1 つが無効な形式です。',},
    {messageId: 'CSM01999M266E', messageContent: 'オブジェクト参照がオブジェクト インスタンスに設定されていません。',},
    {messageId: 'CSM01999M267E', messageContent: 'XML エラーが発生しました。',},
    {messageId: 'CSM01999M268E', messageContent: 'データ登録に失敗しました。',},
    {messageId: 'CSM01999M269E', messageContent: '既に読み取られているバーコード情報です。',},
    {messageId: 'CSM01999M270E', messageContent: 'I/O エラーが発生しました。',},
    {messageId: 'CSM01999M271E', messageContent: '値をNullにすることはできません。パラメーター名:{1}',},
    {messageId: 'CSM01999M272E', messageContent: '{2}パラメーター名:{1}',},
    {messageId: 'CSM01999M274E', messageContent: 'ヘッダレコード作成に失敗しました。',},
    {messageId: 'CSM01999M275E', messageContent: 'ページ区切りレコード作成に失敗しました。',},
    {messageId: 'CSM01999M276E', messageContent: 'エンドレコード作成に失敗しました。',},
    {messageId: 'CSM01999M277E', messageContent: '抜き取りファイル作成に失敗しました。',},
    {messageId: 'CSM01999M278I', messageContent: '■ファイル出力先：{1}',},
    {messageId: 'CSM01999M279E', messageContent: '引当処理に失敗しました。承認番号が正しくないか、引当可能な支払状況が存在しません。：{1}中にエラーが発生しました。',},
    {messageId: 'CSM01999M280E', messageContent: '引当処理に失敗しました。他のユーザにより、引当が実施された可能性があります。',},
    {messageId: 'CSM01999M281E', messageContent: '引当処理に失敗しました。他のユーザにより、引当が実施された可能性があります。：{1}中にエラーが発生しました。',},
    {messageId: 'CSM01999M293E', messageContent: '◆検索ボタン押下で例外エラーが発生しました。',},
    {messageId: 'CSM01999M294I', messageContent: 'コミットしました。{1}',},
    {messageId: 'CSM01999M295I', messageContent: 'ロールバックしました。{1}',},
    {messageId: 'CSM01999M296I', messageContent: 'コネクションが破棄されました。{1}',},
    {messageId: 'CSM01999M297E', messageContent: 'DBのロールバック処理を実行できません。(DML&DDL)',},
    {messageId: 'CSM01999M298E', messageContent: 'ユーザ情報のロールバック処理を実行できません。',},
    {messageId: 'CSM01999M299I', messageContent: '登録値',},
    {messageId: 'CSM01999M301I', messageContent: '■件数 : {1}',},
    {messageId: 'CSM01999M302E', messageContent: '◆変更ボタン押下で例外エラーが発生しました。',},
    {messageId: 'CSM01999M303I', messageContent: '「Y」キーが押下されたため、DB登録処理を実施します。',},
    {messageId: 'CSM01999M304I', messageContent: '「N」キーが押下されたため、DB登録処理を中止します。',},

    {messageId: 'CSS01000M007E', messageContent: '予期せぬエラーが発生しました。',},
    {messageId: 'CSS01044M001E', messageContent: '値をNullにすることはできません。',},
    {messageId: 'CSS01053M001E', messageContent: 'xmlファイルの読込に失敗しました。',},
    {messageId: 'CSS01087M001E', messageContent: '日付フォーマットチェックに失敗しました。',},
    {messageId: 'CSS01087M002E', messageContent: '日付フォーマット整形に失敗しました。',},
    {messageId: 'CSS01088M001E', messageContent: '値が有効な範囲にありません。',},
    {messageId: 'CSS01089M001E', messageContent: '引数に不正な値が設定されています。',},
    {messageId: 'CSS01090M001E', messageContent: '引数に不正な値が設定されています。',},
    {messageId: 'CSS01091M001E', messageContent: '引数に不正な値が設定されています。',},
    {messageId: 'CSS01094M001E', messageContent: '引数に不正な値が設定されています。',},
    {messageId: 'CSS01098M001E', messageContent: '引数に不正な値が設定されています。',},
    {messageId: 'CSS01101M001E', messageContent: '引数に不正な値が設定されています。',},
    {messageId: 'CSS01102M001E', messageContent: '引数に不正な値が設定されています。',},

  ];
}

/**
 * メッセージ(値埋め込み前のメッセージ)の型
 */
export interface MessageOriginVO {
  /**
   * メッセージID
   */
  messageId: string;

  /**
   * メッセージコンテンツ(埋め込みパラメータは埋め込まれていない状態)
   */
  messageContent: string;
}
